'use strict';

var log = require('../../log/Log').channel('SetupController');
var defaults = require('../../defaults/Defaults');
var moment = require('moment');

angular.module('inara').controller('SetupController', SetupController);

SetupController.$inject = ['$rootScope', '$scope', '$state', '$timeout',
    '$interval', '$window', '$ionicPopup', 'RoomService', 'KayleeService',
    'Idle', 'gettextCatalog'];

function SetupController($rootScope, $scope, $state, $timeout,
    $interval, $window, $ionicPopup, RoomService, KayleeService,
    Idle, gettextCatalog) {
    var idleTimeout;
    var offIdleTimeout = null;
    var finishTimeout = null;
    var finishTimeInterval = 1000;
    var finishTimeLeft = 0;
    var idleTimeoutPopup = null;
    var hasKeyboard = angular.isDefined($window.cordova) &&
                      angular.isDefined($window.cordova.plugins) &&
                      angular.isDefined($window.cordova.plugins.Keyboard);
    var controllerPairedWhenStarted;

    $scope.inaraName = defaults.inara.name;

    log.info('initializing');

    $scope.clearSetupData = function(delay) {
        if (angular.isNumber(delay)) {
            $timeout(function() {
                $scope.setup = {};
            }, delay);
            return;
        }
        $scope.setup = {};
    };

    $scope.clearSetupData();

    $scope.$on('$stateChangeSuccess', onStateChanged);

    $scope.goTo = function(stateName) {
        $timeout(function() {
            $state.go(stateName);
        }, defaults.inara.setupPageFlipDelay);
    };

    $scope.getFinishDuration = function() {
        if (finishTimeLeft === 0) return '';

        var defaultSecondsMaxThreshold = moment.relativeTimeThreshold('s');
        var defaultSecondsMinThreshold = moment.relativeTimeThreshold('ss');
        var defaultRounding = moment.relativeTimeRounding();

        moment.relativeTimeThreshold('s', 61);
        moment.relativeTimeThreshold('ss', 0);
        moment.relativeTimeRounding(Math.ceil);
        var duration = moment(Date.now() + finishTimeLeft).fromNow();
        moment.relativeTimeThreshold('s', defaultSecondsMaxThreshold);
        moment.relativeTimeThreshold('ss', defaultSecondsMinThreshold);
        moment.relativeTimeRounding(defaultRounding);
        return duration;
    };

    $scope.finishTimedOut = function () {
        return finishTimeLeft === 0;
    };

    $scope.getCompanyName = function() {
        if (!RoomService.isRoomLoaded()) return '';
        var room = RoomService.getRoom();
        return KayleeService.getCompany(room.companyId).name;        
    };

    $scope.getSiteName = function() {
        if (!RoomService.isRoomLoaded()) return '';
        var room = RoomService.getRoom();
        return KayleeService.getSite(room.siteId).name;
    };

    $scope.getRoomName = function() {
        if (!RoomService.isRoomLoaded()) return '';
        var room = RoomService.getRoom();
        return room.name;
    };

    $scope.getStartViewTitle = function() {
        return gettextCatalog.getString('Welcome to {{inaraName}} Setup', 
            { inaraName: defaults.inara.name });
    };

    function onStateChanged(event, toState, toParams, fromState, fromParams) {
        if (toState.name === 'setup.start') {
            controllerPairedWhenStarted =
                RoomService.isControllerLoaded() &&
                RoomService.getController() !== null &&
                RoomService.getController().$isPaired();
        }

        if (!fromState.name.startsWith('setup.') &&
            toState.name.startsWith('setup.')) {
            onEnterView();
        }

        if (fromState.name.startsWith('setup.') &&
            !toState.name.startsWith('setup.')) {
            onLeaveView();
        }

        if (toState.name === 'setup.start') {
            $scope.clearSetupData();
            $timeout(function() {
                if ($state.is('setup.start')) $state.go('setup.language');
            }, 2000);
        }

        if (toState.name.startsWith('setup.')) {
            log.debug('Setup: \n' + angular.toJson($scope.setup, 4));            
        }
    }

    function onRoomServiceStateChanged() {
        if (RoomService.isControllerLoaded() &&
            RoomService.getController() !== null &&
            RoomService.getController().$isPaired()) {

            setIdleTimeout(defaults.inara.setupIdleTimeout);
            log.debug('controller is paired, starting idle timer');
            Idle.watch();

            // In the case where a controller is quickly unpaired and then
            // remotely repaired (such as when moving a room on Mal), we
            // sometimes see Inara get stuck in setup. This is because
            // unpairing causes Inara to go to setup, but there is no
            // automatic transition back if Inara gets repaired remotely.
            // This case is meant to detect that and handle it.

            log.debug('controllerPairedWhenStarted = ' + controllerPairedWhenStarted);
            if (angular.isDefined(controllerPairedWhenStarted) &&
                !controllerPairedWhenStarted &&
                ($state.is('setup') || $state.is('setup.start') || $state.is('setup.language'))) {
                log.debug('onRoomServiceStateChanged: forcing transition to start');
                $state.go('start');
            }
        } else if (Idle.running()) {
            log.debug('controller is unpaired, stopping idle timer');
            Idle.unwatch();
        }
    }

    function removeOnIdle() {
        if (offIdleTimeout !== null) {
            offIdleTimeout();
            offIdleTimeout = null;
        }
    }

    function setIdleTimeout(value) {
        var timeout = parseFloat(value) * 60;
        var limit = 2;

        if (timeout < limit) {
            log.error('setIdleTimeout: ' + timeout + ' limited to ' + limit);
            timeout = limit;
        }

        idleTimeout = timeout;
        log.debug('setIdleTimeout: ' + idleTimeout);
        Idle.setIdle(1);
        Idle.setTimeout(timeout - 1); // subtract idle time to correct total
    }

    function onEnterView() {
        log.debug('onEnterView');
        removeOnIdle();
        offIdleTimeout = $scope.$on('IdleTimeout', onIdleTimeout);
        RoomService.onStateChanged(onRoomServiceStateChanged);
    }

    function onLeaveView() {
        log.debug('onLeaveView');
        Idle.unwatch();
        removeOnIdle();
        cancelFinishTimeout();
        RoomService.offStateChanged(onRoomServiceStateChanged);
        if (idleTimeoutPopup !== null) {
            idleTimeoutPopup.close(false);
        }
    }

    function onIdleTimeout() {
        log.debug('onIdleTimeout');
        finishTimeLeft = defaults.inara.setupFinishTimeout;
        finishTimeout = $interval(onFinishTimeout, finishTimeInterval);
        if (hasKeyboard &&
            $window.cordova.plugins.Keyboard.isVisible) {
            $window.cordova.plugins.Keyboard.close();
        }

        idleTimeoutPopup = $ionicPopup.show({
            templateUrl: 'setupTimeoutPopup.html',
            cssClass: 'setup-timeout-popup',
            scope: $scope,
            buttons: [
                { 
                    /// Button text for dialog displayed during setup to confirm user presence
                    /// confirmation dialog displayed if user has been idle for too long.
                    text: gettextCatalog.getString('I\'m still here!'),
                    type: 'button-setup',
                    onTap: function(e) {
                        return true;
                    }
                },
            ]
        });

        idleTimeoutPopup.then(function(res) {
            if (res) {
                Idle.watch();
                cancelFinishTimeout();
                log.debug('remaining in setup', res);
            }
        });
    }

    function onFinishTimeout() {
        if (finishTimeLeft > 0) {
            finishTimeLeft -= finishTimeInterval;
        }
        else {
            log.debug('setup finish timeout, finishing');
            cancelFinishTimeout();
            $state.go('start');
        }
    }

    function cancelFinishTimeout() {
        if (finishTimeout !== null) {
            $interval.cancel(finishTimeout);
            finishTimeout = null;
        }
    }
}

module.exports = SetupController;
